module.exports = __webpack_public_path__ + "14d50434534a2543b88a92c7c68a3f23.svg";